import { useState, useEffect } from 'react';

export default function HomePage() {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const currentUrl = window.location.href;
  const shareTitle = '60ケチキン - リンク集';

  const shareOptions = [
    {
      name: 'X (Twitter)',
      icon: 'ri-twitter-x-line',
      color: 'bg-black',
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(shareTitle)}`,
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-fill',
      color: 'bg-blue-600',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
    },
    {
      name: 'LINE',
      icon: 'ri-line-fill',
      color: 'bg-green-500',
      url: `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(currentUrl)}`,
    },
    {
      name: 'WhatsApp',
      icon: 'ri-whatsapp-fill',
      color: 'bg-green-600',
      url: `https://wa.me/?text=${encodeURIComponent(shareTitle + ' ' + currentUrl)}`,
    },
  ];

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = (url: string) => {
    window.open(url, '_blank', 'width=600,height=400');
  };

  const links = [
    {
      id: 1,
      title: 'Amazonで評価の高い服を厳選✨\nすべて動画の中で紹介したアイテムです🎦\n気になる商品はタップ👇',
      type: 'text',
    },
    {
      id: 16,
      title: '綿100％うるおい美容キャミ',
      url: 'https://amzn.to/3NeYzPP',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/7902b7dedaac77c2a7290a1057c6e631.jpeg',
    },
    {
      id: 19,
      title: '美脚＆美尻ヨガレギンス',
      url: 'https://amzn.to/4svCUC6',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/bba23da051de42e5cf29237f364bcd07.jpeg',
    },
    {
      id: 27,
      title: 'ラクすぎる定番クロックス',
      url: 'https://amzn.to/4v1O8At',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/58b23676-0f75-4cc7-bb7b-bb08db80a08d_71aO1V7phzL._AC_SX575_.jpg?v=f6dc4003b959a7fb72461b6edbdbe0d4',
    },
    {
      id: 25,
      title: '着痩せ叶う上品リブニット',
      url: 'https://amzn.to/4lT3dQp',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/779901ef-a4b5-405b-9ffa-c6992b9da36c_7115yiKcxqL._AC_SX679_.jpg?v=cdc9d986961005ae6df1509550ead223',
    },
    {
      id: 26,
      title: '歩くたび可愛いチュールスカート',
      url: 'https://amzn.to/4m3SfIb',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/8e59efc6-cf2c-460d-a557-927d43d2a59a_61KgLu2gyuL._AC_SX679_.jpg?v=8b8ceec292fe3490cc256dbdcee83b07',
    },
    {
      id: 17,
      title: 'さらっと快適ショートパンツ',
      url: 'https://amzn.to/4bw7DsY',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/7597f91898f024f99937315a4511e376.jpeg',
    },
    {
      id: 22,
      title: '上品可愛い千鳥柄ブラウス',
      url: 'https://amzn.to/4uAxDuF',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/e5020893-2933-4221-a74d-42d98c257f35_71jexErb0PL._AC_SX679_.jpg?v=9a9dc1a4ca45f509ed490eae7166667d',
    },
    {
      id: 23,
      title: '美シルエット伸びるタイトスカート',
      url: 'https://amzn.to/4uEnr4t',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/9c3a7f919b95c2fb74878bd506332def.png',
    },
    {
      id: 24,
      title: '素肌みたいな美脚ストッキング',
      url: 'https://amzn.to/4bUDcwK',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/a992d22b-a402-484a-8129-cc78fb81bb8b_61AIWOwQHFL._AC_SX679_.jpg?v=3b4fea6c0b337e17ceb12c8340acee3f',
    },
    {
      id: 20,
      title: '小顔見えUVカット帽子',
      url: 'https://amzn.to/4dmNiHP',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/3db14d5c5f1104c9f06aa53a10741aa0.jpeg',
    },
    {
      id: 21,
      title: '上品シンプルレディース腕時計',
      url: 'https://amzn.to/4uxkUch',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/69218a0c-91d4-4124-a198-73e320a564f4_61MTOfS89oL._AC_SY550_.jpg?v=003b72e3f22b1dd6823beeb2dcab1fa0',
    },
    {
      id: 10,
      title: 'やわらか着痩せチュニック',
      url: 'https://amzn.to/3MS122B',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/b1f170bab2df586fbae516c6175ee3e1.jpeg',
    },
    {
      id: 11,
      title: '美シルエット楽ちんカーゴパンツ',
      url: 'https://amzn.to/4cLOmER',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/2ca515f8c47a024dc7be6da5df652bf7.jpeg',
    },
    {
      id: 18,
      title: 'ゆるっと着痩せロングTシャツ',
      url: 'https://amzn.to/3OWLbRa',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/ce44b128e1b8cc0f3c0e389277dbf642.jpeg',
    },
    {
      id: 14,
      title: '綿混やわらか10色ソックス',
      url: 'https://amzn.to/4r0vzt6',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/0c344c656a1c6751c47d21e19e06dc30.jpeg',
    },
    {
      id: 15,
      title: 'こなれ感ゆるトレーナー',
      url: 'https://amzn.to/40sQqup',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/963ee42f6e54a8e7228d01f8841bdb68.jpeg',
    },
    {
      id: 12,
      title: '軽やか美脚厚底スニーカー',
      url: 'https://amzn.to/4u1Q77l',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/e5620649be180de6793996d8c7c3f1f4.jpeg',
    },
    {
      id: 13,
      title: '綿100％やさしいゆったりパジャマ',
      url: 'https://amzn.to/3MUUakV',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/9da15ea59ce4ee4e9b345fb7836d0ff3.jpeg',
    },
    {
      id: 8,
      title: '体型隠せる楽かわワンピース',
      url: 'https://amzn.to/4aPnJNU',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/fe601951d115bc8e726ff04861f755bf.jpeg',
    },
    {
      id: 9,
      title: '軽くて頼れる万能ジャケット',
      url: 'https://amzn.to/4kzkddK',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/d5b82ba668c5baeaa15d30a8212b03f7.jpeg',
    },
    {
      id: 2,
      title: '小顔見え＆着痩せ叶うニット',
      url: 'https://amzn.to/4kk6o2U',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/921a3323d8c7c1fcaffcae16cf617279.jpeg',
    },
    {
      id: 3,
      title: '美脚＆抜群ストレッチスキニー',
      url: 'https://amzn.to/3ZV5CzX',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/d6a747c0c9be9ed84275fb83d0eae0e4.jpeg',
    },
    {
      id: 4,
      title: '痛くなりにくい楽々美脚パンプス',
      url: 'https://amzn.to/4rGuQy4',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/2cd67acf912897e6dd7905dfef336dd5.png',
    },
    {
      id: 5,
      title: '超軽量＆9ポケット 万能トート',
      url: 'https://amzn.to/4ajlq4p',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/f9cd6db117f0268ddd53dedc6b93c668.png',
    },
    {
      id: 6,
      title: 'お腹すっきり ノーバックルベルト',
      url: 'https://amzn.to/45UL7a8',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/801cb4e9afc3dec991eb83cc8c4e7a3b.jpeg',
    },
    {
      id: 28,
      title: '視線奪う美ラインミニワンピ',
      url: 'https://amzn.to/4m9YoTb',
      image: 'https://storage.readdy-site.link/project_files/be4a7efc-6f1e-4017-8f75-49332f169c41/abec04be-5164-4902-bbfd-0c51c13f369f_61vRsc1cnfL._AC_SY741_.jpg?v=389d6ec1f881f29d0f602339ce4fc347',
    },
    {
      id: 7,
      title: '胸元きらめく 上品細見えネックレス',
      url: 'https://amzn.to/3ObHF4M',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/a725680771340eb063a4319e3e863977.jpeg',
    },
    {
      id: 29,
      title: 'ピンポイントで効く振動ケア',
      url: 'https://amzn.to/4drfg5t',
      image: 'https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/6d9a69c7cd6beeaf168f01733bce101e.jpeg',
    },
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/satou_misaki_style?igsh=cW10Nmp3ZXVyemI0' },
    { icon: 'ri-youtube-line', url: 'https://www.youtube.com/channel/UCeIW3SoMJvJDND7tGhwKTlw' },
    { icon: 'ri-tiktok-line', url: 'https://www.tiktok.com/@satou_misaki285?_r=1&_t=ZS-93ixqYlXckj' },
    { icon: 'ri-twitter-x-line', url: 'https://x.com/Satou_Misaki285' },
  ];

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.message) return;
    
    setIsSubmitting(true);
    setSubmitStatus('idle');
    
    try {
      const response = await fetch('https://readdy.ai/api/form/d65d73v0ioc4omtka9pg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }).toString(),
      });
      
      if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => {
          setShowEmailModal(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setSubmitStatus('idle');
  };

  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: `${siteUrl}/`,
          name: '佐藤美咲のAmazonコーデ',
          description: '佐藤美咲が厳選したAmazonで評価の高い服やアイテムをご紹介。着痩せ・美脚・小顔見えなど、おしゃれで快適なコーディネートアイテムが満載。',
          inLanguage: 'ja',
          publisher: {
            '@id': `${siteUrl}/#person`,
          },
        },
        {
          '@type': 'Person',
          '@id': `${siteUrl}/#person`,
          name: '佐藤美咲',
          alternateName: 'satou_misaki',
          url: `${siteUrl}/`,
          image: {
            '@type': 'ImageObject',
            url: 'https://d13k46lqgoj3d6.cloudfront.net/2021/9/1/2021-9-1-1630485515507.png?w=600&f=png',
          },
          sameAs: [
            'https://www.instagram.com/satou_misaki_style',
            'https://www.youtube.com/channel/UCeIW3SoMJvJDND7tGhwKTlw',
            'https://www.tiktok.com/@satou_misaki285',
            'https://x.com/Satou_Misaki285',
          ],
        },
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: `${siteUrl}/`,
          name: '佐藤美咲のAmazonコーデ｜着痩せ・美脚・小顔見えアイテム厳選',
          description: '佐藤美咲が厳選したAmazonで評価の高い服やアイテムをご紹介。着痩せ・美脚・小顔見えなど、おしゃれで快適なコーディネートアイテムが満載。',
          inLanguage: 'ja',
          isPartOf: { '@id': `${siteUrl}/#website` },
          about: { '@id': `${siteUrl}/#person` },
          dateModified: '2025-07-10',
        },
        {
          '@type': 'ItemList',
          '@id': `${siteUrl}/#itemlist`,
          name: '佐藤美咲 厳選Amazonアイテム',
          description: '着痩せ・美脚・小顔見えを叶えるAmazon厳選コーデアイテム一覧',
          url: `${siteUrl}/`,
          numberOfItems: 10,
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'やわらか着痩せチュニック',
              url: 'https://amzn.to/3MS122B',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '美シルエット楽ちんカーゴパンツ',
              url: 'https://amzn.to/4cLOmER',
            },
            {
              '@type': 'ListItem',
              position: 3,
              name: '体型隠せる楽かわワンピース',
              url: 'https://amzn.to/4aPnJNU',
            },
            {
              '@type': 'ListItem',
              position: 4,
              name: '軽くて頼れる万能ジャケット',
              url: 'https://amzn.to/4kzkddK',
            },
            {
              '@type': 'ListItem',
              position: 5,
              name: '小顔見え＆着痩せ叶うニット',
              url: 'https://amzn.to/4kk6o2U',
            },
            {
              '@type': 'ListItem',
              position: 6,
              name: '美脚＆抜群ストレッチスキニー',
              url: 'https://amzn.to/3ZV5CzX',
            },
            {
              '@type': 'ListItem',
              position: 7,
              name: '痛くなりにくい楽々美脚パンプス',
              url: 'https://amzn.to/4rGuQy4',
            },
            {
              '@type': 'ListItem',
              position: 8,
              name: '超軽量＆9ポケット 万能トート',
              url: 'https://amzn.to/4ajlq4p',
            },
            {
              '@type': 'ListItem',
              position: 9,
              name: 'お腹すっきり ノーバックルベルト',
              url: 'https://amzn.to/45UL7a8',
            },
            {
              '@type': 'ListItem',
              position: 10,
              name: '胸元きらめく 上品細見えネックレス',
              url: 'https://amzn.to/3ObHF4M',
            },
          ],
        },
      ],
    };

    const existingScript = document.getElementById('schema-jsonld');
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.id = 'schema-jsonld';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-jsonld');
      if (s) s.remove();
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="max-w-2xl mx-auto px-4 py-8 pb-32">
        {/* Banner Ad */}
        <a
          href="https://www.eldoah.com/?ad=starmine"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="block mb-6 overflow-hidden shadow-sm hover:shadow-md transition-shadow cursor-pointer"
        >
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/656d366f4ccca6058eeaa95cb96b6642.png"
              alt="ELDOAH Casino Welcome Bonus"
              className="w-full h-auto object-cover"
            />
            <div className="bg-[#1a1008] px-4 py-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-1">
              <span className="text-xs text-yellow-400 font-medium whitespace-nowrap">
                <i className="ri-user-line mr-1"></i>紹介者ID：<strong className="text-white">starmine</strong>
              </span>
              <span className="text-xs text-yellow-400 font-medium whitespace-nowrap">
                <i className="ri-coupon-line mr-1"></i>プロモーションコード：<strong className="text-white">2000bonus</strong>
              </span>
            </div>
          </div>
        </a>

        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div className="text-lg font-semibold text-gray-800">satou_misaki</div>
          <div className="flex gap-3">
            <button
              onClick={() => setShowEmailModal(true)}
              className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              aria-label="Email"
            >
              <i className="ri-mail-line text-gray-700 text-lg"></i>
            </button>
            <button
              onClick={() => setShowShareModal(true)}
              className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              aria-label="Share"
            >
              <i className="ri-share-line text-gray-700 text-lg"></i>
            </button>
          </div>
        </div>

        {/* Cover Image & Profile */}
        <div className="bg-white rounded-3xl shadow-sm overflow-hidden mb-6">
          <div className="relative">
            <div className="w-full h-48 overflow-hidden">
              <img
                src="https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/3a6fb357051d66683e1c29fea5d89332.png"
                alt="60chicken cover"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Links Section */}
        <div className="space-y-4">
          {links.map((link) => (
            <div key={link.id}>
              {link.type === 'text' ? (
                <div className="py-3">
                  <p className="text-gray-800 text-center font-medium whitespace-pre-line">{link.title}</p>
                </div>
              ) : (
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow overflow-hidden cursor-pointer"
                >
                  <div className="flex items-center gap-4 p-4">
                    <div className="w-16 h-16 flex-shrink-0 rounded-xl overflow-hidden">
                      <img
                        src={link.image}
                        alt={link.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-800 text-sm font-medium line-clamp-2">
                        {link.title}
                      </p>
                    </div>
                  </div>
                </a>
              )}
            </div>
          ))}
        </div>

        {/* Social Links */}
        <div className="mt-8 mb-6">
          <div className="flex justify-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              >
                <i className={`${social.icon} text-gray-700 text-xl`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="pb-8 text-center">
          <p className="text-xs text-gray-400 leading-relaxed">
            本サイトはAmazonアソシエイト・プログラムに参加しています。<br />
            当サイトを経由してAmazonで購入された場合、紹介料を受け取ることがあります。
          </p>
        </div>
      </div>

      {/* Scroll to Top Button */}
      {showScrollTop && (
        <button
          onClick={handleScrollTop}
          className="fixed bottom-20 right-4 z-50 w-11 h-11 flex items-center justify-center bg-gray-900/80 hover:bg-gray-900 text-white rounded-full shadow-lg backdrop-blur-sm transition-all duration-300 cursor-pointer"
          aria-label="トップへ戻る"
        >
          <i className="ri-arrow-up-line text-lg"></i>
        </button>
      )}

      {/* Fixed Anchor Banner Ad */}
      <div className="fixed bottom-0 left-0 right-0 z-40 flex justify-center shadow-[0_-4px_16px_rgba(0,0,0,0.15)]">
        <a
          href="https://www.eldoah.com/?ad=starmine"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="block w-full max-w-2xl cursor-pointer"
        >
          <img
            src="https://static.readdy.ai/image/3fcca03a3d543e418fbbfa46bda9410a/85262676bdb0408efb272b546894e0d4.png"
            alt="ELDOAH Casino"
            className="w-full h-auto object-cover"
          />
        </a>
      </div>

      {/* Email Modal */}
      {showEmailModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={handleCloseEmailModal}
        >
          <div
            className="bg-white rounded-2xl p-6 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-gray-900">お問い合わせ</h3>
              <button
                onClick={handleCloseEmailModal}
                className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>
            
            {submitStatus === 'success' ? (
              <div className="text-center py-6">
                <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-green-600"></i>
                </div>
                <p className="text-gray-800 font-medium">送信完了しました</p>
                <p className="text-gray-500 text-sm mt-1">お問い合わせありがとうございます</p>
              </div>
            ) : (
              <form 
                id="contact-form"
                data-readdy-form
                onSubmit={handleFormSubmit}
              >
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">お名前</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                      placeholder="山田 太郎"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">メールアドレス</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
                      placeholder="example@email.com"
                      required
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">お問い合わせ内容</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={(e) => setFormData({ ...formData, message: e.target.value.slice(0, 500) })}
                      className="w-full px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent resize-none"
                      rows={4}
                      placeholder="お問い合わせ内容をご記入ください"
                      maxLength={500}
                      required
                    />
                    <p className="text-xs text-gray-400 text-right mt-1">{formData.message.length}/500</p>
                  </div>
                </div>
                
                {submitStatus === 'error' && (
                  <p className="text-red-500 text-sm mt-3">送信に失敗しました。もう一度お試しください。</p>
                )}
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gray-900 hover:bg-gray-800 disabled:bg-gray-400 text-white py-3 px-6 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap mt-5"
                >
                  {isSubmitting ? '送信中...' : '送信する'}
                </button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* Share Modal */}
      {showShareModal && (
        <div
          className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-50"
          onClick={() => setShowShareModal(false)}
        >
          <div
            className="bg-white rounded-t-3xl sm:rounded-2xl p-6 w-full sm:max-w-sm"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-lg font-bold text-gray-900">共有する</h3>
              <button
                onClick={() => setShowShareModal(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            {/* SNS Share Buttons */}
            <div className="grid grid-cols-4 gap-4 mb-6">
              {shareOptions.map((option) => (
                <button
                  key={option.name}
                  onClick={() => handleShare(option.url)}
                  className="flex flex-col items-center gap-2 cursor-pointer group"
                >
                  <div className={`w-14 h-14 flex items-center justify-center ${option.color} rounded-full group-hover:scale-110 transition-transform`}>
                    <i className={`${option.icon} text-white text-2xl`}></i>
                  </div>
                  <span className="text-xs text-gray-600">{option.name}</span>
                </button>
              ))}
            </div>

            {/* Copy Link */}
            <div className="border-t pt-4">
              <button
                onClick={handleCopyLink}
                className="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 py-3 px-4 rounded-full transition-colors cursor-pointer"
              >
                <i className={`${copied ? 'ri-check-line text-green-600' : 'ri-link'} text-lg`}></i>
                <span className="text-sm font-medium text-gray-700">
                  {copied ? 'コピーしました!' : 'リンクをコピー'}
                </span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
